// eslint-disable-next-line import/no-anonymous-default-export
export default {
  formId: "new-PA-form",
  formField: {
    // datas
    number: {
      name: "number",
      label: "Número",
      type: "text",
      errorMsg: "O número é obrigatório",
      invalidMsg: "Número inválido",
    },
    name: {
      name: "name",
      label: "Nome",
      type: "text",
      errorMsg: "O nome é obrigatório",
      invalidMsg: "Nome inválido",
    },
    regional: {
      name: "regional",
      label: "Regional",
      type: "text",
      errorMsg: "O regional é obrigatório",
      invalidMsg: "Regional inválido",
    },
  },
};